import React, { useState } from "react";
import Loader from "../Loader";
import iconArrowSimpleDown from "../assets/icons/Arrow Simple/Down.svg";
import iconArrowSimpleUp from "../assets/icons/Arrow Simple/Up.svg";
import iconStateOk from "../assets/icons/State/Ok.svg";
import iconStateNotOk from "../assets/icons/State/Not Ok.svg";
import { styleBlock } from "../styleBlock";
import Tooltip from "../Tooltip";
export var QueueItemType;
(function (QueueItemType) {
    QueueItemType[QueueItemType["COMPLETE"] = 1] = "COMPLETE";
    QueueItemType[QueueItemType["FAIL"] = 2] = "FAIL";
    QueueItemType[QueueItemType["IN_PROGRESS"] = 3] = "IN_PROGRESS";
})(QueueItemType || (QueueItemType = {}));
const DownloadingQueue = (props) => {
    const { title, items, onClick } = props;
    const [isOpen, setOpen] = useState(true);
    const b = styleBlock("downloading_queue");
    if (items.length === 0) {
        return null;
    }
    const itemData = items.map((item) => {
        let icon;
        const handleOnCLick = () => onClick(item);
        switch (item.type) {
            case QueueItemType.FAIL:
                icon = React.createElement("img", { src: iconStateNotOk, alt: "not ok" });
                break;
            case QueueItemType.IN_PROGRESS:
                icon = React.createElement(Loader, { small: true });
                break;
            default:
                icon = React.createElement("img", { src: iconStateOk, alt: "ok" });
                break;
        }
        return (React.createElement("div", { className: "item", key: `notification-item-${item.id}` },
            React.createElement("span", { className: "item_content", onClick: handleOnCLick, title: item.label }, item.label),
            item.message ? (React.createElement(Tooltip, { id: `notification-tooltip-${item.id}`, tooltip: item.message, placement: "top-end" },
                React.createElement("span", { "aria-label": item.message }, icon))) : (icon)));
    });
    return (React.createElement("div", { className: b.toString() },
        React.createElement("h1", { onClick: () => setOpen(!isOpen) },
            title,
            " ",
            React.createElement("img", { src: isOpen ? iconArrowSimpleDown : iconArrowSimpleUp, alt: "arrow" })),
        isOpen && React.createElement("section", null, itemData)));
};
export default DownloadingQueue;
//# sourceMappingURL=index.js.map